// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2V0rg","name":"ConsentHeader_name__A8JOj","birthday":"ConsentHeader_birthday__1PVp2","skeleton":"ConsentHeader_skeleton__3cFMF"};